<template>
    <b-card no-body class="d-flex flex-row mb-2">
        <a href="#" class="d-flex">
            <ThumbnailImage rounded small :src="'/storage/images/users/' + data.data.attributes.image" alt="profile" class-name="m-4"/>
        </a>
        <div class=" d-flex flex-grow-1 min-width-zero">
            <b-card-body
                class=" pl-0 align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero">
                <div class="min-width-zero">
                    <a href="#">
                        <b-card-sub-title class="truncate mb-1">{{data.data.attributes.name}}</b-card-sub-title>
                    </a>
                    <b-card-text class="text-muted text-small mb-2">{{data.data.attributes.position}}</b-card-text>
                </div>
            </b-card-body>
        </div>
    </b-card>
</template>
<script>
    import ThumbnailImage from "./ThumbnailImage";

    export default {
        props: ['data'],
        components: {
            ThumbnailImage,
        },
    }
</script>
